module.exports = __webpack_public_path__ + "assets/img/ec.8e4e535b.png";